import React from 'react';
import PropTypes from 'prop-types';
import { AButtonSwitch } from '../atoms';

export default function MButtonSwitch({
	label,
	items,
	index,
	disabled,
	className,
	onChange,
}) {
	return (
		<div className="m-input-field">
			<label>{label}</label>
			<AButtonSwitch
				items={items}
				index={index}
				disabled={disabled}
				className={className}
				onClick={onChange}
			/>
		</div>
	);
}

MButtonSwitch.propTypes = {
	items: PropTypes.array.isRequired,
	label: PropTypes.string,
	index: PropTypes.number,
	disabled: PropTypes.bool,
	className: PropTypes.string,
	onChange: PropTypes.func,
};

MButtonSwitch.defaultProps = {
	index: 0,
	label: '',
	disabled: false,
	className: '',
	onChange: undefined,
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.button-switch.js